<div class="display--flex">
    <div class="display--full-width">
        <div
            class="input-wrapper file-picker__input-wrapper file-picker__input-wrapper--new">
            <div class="select-wrapper">
                <div
                    class="select-value display--flex">
                    <div
                        class="display--nowrap display--full-width"
                        [ngClass]="{'input-placeholder': !fileName}"
                        (click)="handlePick()"
                        [tooltip]="fileName">
                        {{ fileName || placeholder}}
                    </div>
                    <div class="file-picker__buttons">
                        <div
                            class="form-button"
                            (click)="handlePick()"
                            [tooltip]="'ui.file-picker.buttons.select' | translate">
                            <skl-icon
                                name="download">
                            </skl-icon>
                        </div>
                        @if (fileName) {
                            <div
                                class="form-button"
                                [tooltip]="'ui.file-picker.buttons.delete' | translate"
                                (click)="handleClear()">
                                <skl-icon
                                    name="cross">
                                </skl-icon>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
        <ins-filepicker
            #filepicker
            [hidden]="true"
            [accept]="accept">
        </ins-filepicker>
    </div>
</div>